import { render } from "./slide-verify.vue?vue&type=template&id=6d83cd9a&scoped=true"
import script from "./slide-verify.vue?vue&type=script&lang=js"
export * from "./slide-verify.vue?vue&type=script&lang=js"

import "./slide-verify.vue?vue&type=style&index=0&id=6d83cd9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d83cd9a"]])

export default __exports__